import { INIT_DASHBOARD_REQUEST, SUBSCRIPTION_CHANGED } from './dashboardActionTypes';

export interface InitDashboardRequest {
  type: typeof INIT_DASHBOARD_REQUEST;
}

export interface SubscriptionChanged {
  type: typeof SUBSCRIPTION_CHANGED;
  payload: { subscriptionId: number };
}

export const initDashboardRequest = (): InitDashboardRequest => ({
  type: INIT_DASHBOARD_REQUEST,
});

export const subscriptionChanged = (payload: { subscriptionId: number }): SubscriptionChanged => ({
  type: SUBSCRIPTION_CHANGED,
  payload,
});
